module.exports = __webpack_public_path__ + "static/media/brand_logo2.f58c7002.jpg";